import { FormControl, FormHelperText, FormLabel, Input } from "@mui/joy";
import { Controller, useFormContext } from "react-hook-form";

export function FormDate({ name, label, optional }) {
  const form = useFormContext();
  const fieldState = form.getFieldState(name, form.formState);

  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field }) => {
        const handleChange = (e) => {
          const value = e.target.value;
          if (!value) {
            field.onChange(null);
            return;
          }
          const dateString = value.split('T')[0];
          field.onChange(dateString);
        };

        return (
          <FormControl error={!!fieldState.error}>
            {label && <FormLabel>{label} {optional && <span style={{ color: 'var(--joy-palette-neutral-400)' }}>(optional)</span>}</FormLabel>}
            <Input
              type="date"
              value={field.value}
              onChange={handleChange}
              onBlur={field.onBlur}
            />
            {fieldState.error && <FormHelperText>{fieldState.error.message}</FormHelperText>}
          </FormControl>
        );
      }}
    />
  );
}

